var map = {
	"./MEDEUON.png": 1521,
	"./article.pdf": 4694,
	"./article.png": 9792,
	"./case_study.png": 6942,
	"./celibration.gif": 9433,
	"./celibrationnn.gif": 9697,
	"./certificate.gif": 2648,
	"./certificate.jpg": 5715,
	"./cme.png": 4235,
	"./cs.gif": 6305,
	"./dr_reddy.jpg": 8167,
	"./dr_reddy.png": 9271,
	"./journal.pdf": 6145,
	"./journal.png": 3483,
	"./lea.gif": 7199,
	"./sunpharma.png": 1243,
	"./video.png": 1023,
	"./virtual.png": 4815
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7958;